// extracted by mini-css-extract-plugin
module.exports = {"row":"CatalogTaxonomyStatusLine_row__3ELz_","status":"CatalogTaxonomyStatusLine_status__1U-tm","mark":"CatalogTaxonomyStatusLine_mark__22k13"};